import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z","key":"svg-0"}],["path",{"d":"M12 12h9l-1.914 4.912a1.7 1.7 0 0 1 -2.925 .428z","key":"svg-1"}],["path",{"d":"M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z","key":"svg-2"}],["path",{"d":"M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z","key":"svg-3"}]]

const IconCarFan = createReactComponent('outline', 'car-fan', 'CarFan', __iconNode);

export default IconCarFan;